import React, { Fragment, useState } from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../modalComponent/ModalComponent";
import location from "../../Assests_Url/Location.png"
import headerEmbelem from "../../Assests_Url/header embelm.png"
import { IoMdMail } from "react-icons/io";
import { MdCall } from "react-icons/md";

const Footer = ({ setActiveTab, RoutesClick, NcertClick }) => {
  const [routeModal, setRouteModal] = useState(false);
  const [ncertModal, setNcertModal] = useState(false);

  const navigate = useNavigate();

  const homeClick = () => {
    if (window.location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };
  const katbookClick = () => {
    // Navigate to a different route
    navigate("/katbook");
  };
  const UEducateClick = () => {
    // Navigate to a different route
    navigate("/ueducate");
  };
  const EvaluationClick = () => {
    // Navigate to a different route
    navigate("/evaluation");
  };
  return (
    <Fragment>
      <div className="fooNew pt-3">
        <div
          className="container mb-3 pt-2"
          style={{ fontFamily: "'Montserrat', sans-serif", color: "#fff" }}
        >
          <div className="row align-items-center">
            <div className="col-sm-12 col-lg-5">
              <div className="d-flex flex-column justify-content-start gap-4">
                <div className="text_center_mobile">
                   <div
                      style={{ width: "40%", cursor: "pointer" }}
                    >
                      <img
                        src={headerEmbelem}
                        style={{ width: "100%" }}
                      />
                    </div>
                </div>

                <div
                  className="pad-bot"
                  style={{
                    fontSize: "1rem",
                    marginTop: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <span>
                    To know more about the company, please visit{" "}
                    <strong
                      onClick={() =>
                        window.open("https://ueducate.in/", "_blank")
                      }
                      style={{ cursor: "pointer" }}
                    >
                      ueducate.in
                    </strong>
                  </span>{" "}
                </div>

                <div
                  className="pad-bot"
                  style={{
                    fontSize: "1rem",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                    marginTop: "-20px",
                  }}
                >
                  <span> Copyright 2025,</span>{" "}
                  <span style={{ fontWeight: "700" }}>
                    {" "}
                    U-Educate Global Pvt. Ltd.
                  </span>
                </div>

                <div className="webDis" style={{ fontSize: "0.95rem" }}></div>
              </div>
            </div>

            <div className="col-sm-5 col-lg-3">
              <div className="d-flex flex-column justify-content-start gap-3">
                <div className="footer_Quick">Quick Links</div>
                <div
                  className="footer_Quick_content mx-4 "
                  onClick={() => {
                    setActiveTab("Home");
                    homeClick();
                  }}
                >
                  {" "}
                  <span className="cursor textDecvor coWh">Home</span>
                </div>
               
                <div
                  className="footer_Quick_content mx-4 "
                  onClick={() => {
                    setActiveTab("KATBOOK");
                    katbookClick();
                  }}
                >
                  <span className="cursor textDecvor coWh">KATBOOK</span>
                </div>
                 <div
                  className="footer_Quick_content mx-4"
                  onClick={() => {
                    setActiveTab("UEducate");
                    UEducateClick();
                  }}
                >
                  <span className="cursor coWh">UEducate</span>
                </div>
                <div
                  className="footer_Quick_content mx-4"
                  onClick={() => {
                    setActiveTab("Evaluation");
                    EvaluationClick();
                  }}
                >
                  <span className="cursor coWh">Feedback</span>
                </div>
                {/* <div
                className="footer_Quick_content mx-4"
                onClick={() => window.open(`https://diksha.gov.in/`, "_blank")}
              >
                <span className="cursor">DIKSHA</span>
              </div> */}
              </div>
            </div>

            <div className="col-sm-5 col-lg-4">
              <div className="d-flex flex-column justify-content-start gap-3 foottop">
                <div className="footer_Quick">Contact Us</div>
                <div className="d-flex gap-2">
                  <div>
                    <img src={location} />
                  </div>
                  <div className="footer_Quick_content">
                      Agnitio Park, 9th Floor, No: 141, Rajiv Gandhi Salai (OMR), Kandhanchavadi, Chennai - 600096.
                  </div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                <div>
                  {/* <img src="https://cdn.katbook.com/assets/sites/ncert/754664531585798144_mail.png" /> */}
                  <IoMdMail />
                </div>
                <div className="footer_Quick_content">
                  business@ueducate.in
                </div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <div>
                  {/* <img src="https://cdn.katbook.com/assets/sites/ncert/754664531585798144_call.png" /> */}
                  <MdCall />
                </div>
                <div className="footer_Quick_content">+91 70102 44564</div>
              </div>

                {/* <div className='copyrightsfont mobiDis d-flex justify-content-center mt-3 '>Copyright © 2023 katbookstore.com</div> */}
              </div>
            </div>
          </div>
        </div>

        <ModalComponent
          show={routeModal}
          dialogClassName={"ModalSizeMobile"}
          Title={"Routes 2 Roots"}
          onClick={() => {
            setRouteModal(false);
          }}
          Content={
            <div className="d-flex justify-content-center align-items-center height_30">
              <span className="h3">Coming Soon...</span>
            </div>
          }
        />

        <ModalComponent
          show={ncertModal}
          isNcert={true}
          dialogClassName={"ModalSizeMobile"}
          onClick={() => {
            setNcertModal(false);
          }}
        />
      </div>
    </Fragment>
  );
};

export default Footer;
